<template>
    <div>
      <!-- 导航 -->
      <el-breadcrumb>
        <el-breadcrumb-item>
          <router-link to="./">首页</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>日语汇总</el-breadcrumb-item>
      </el-breadcrumb>
      
      <!-- 主体内容 -->
      <div class="content">
        <div style="height: 20px"></div>
        
        <!-- 标题 -->
        <div class="summary-header">
          <h2>日语数据汇总</h2>
          <p class="sub-title">请选择要查看的汇总类型</p>
        </div>
        
        <!-- 六个跳转按钮 -->
        <div class="summary-buttons">
          <div class="button-row">
            <!-- 学历汇总 -->
            <div class="button-item" @click="goToPage('education')">
              <div class="button-icon">
                <i class="el-icon-office-building"></i>
              </div>
              <div class="button-content">
                <h3>学历汇总</h3>
               
              </div>
              <div class="button-arrow">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            
            <!-- 来源汇总 -->
            <div class="button-item" @click="goToPage('source')">
              <div class="button-icon">
                <i class="el-icon-c-scale-to-original"></i>
              </div>
              <div class="button-content">
                <h3>来源汇总</h3>
            
              </div>
              <div class="button-arrow">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
          
          <div class="button-row">
            <!-- 地区汇总 -->
            <div class="button-item" @click="goToPage('region')">
              <div class="button-icon">
                <i class="el-icon-location"></i>
              </div>
              <div class="button-content">
                <h3>地区汇总</h3>
             
              </div>
              <div class="button-arrow">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            
            <!-- 缴费汇总 -->
            <div class="button-item" @click="goToPage('payment')">
              <div class="button-icon">
                <i class="el-icon-money"></i>
              </div>
              <div class="button-content">
                <h3>缴费汇总</h3>
             
              </div>
              <div class="button-arrow">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            
            <!-- 课程汇总 -->
            <div class="button-item" @click="goToPage('course')">
              <div class="button-icon">
                <i class="el-icon-school"></i>
              </div>
              <div class="button-content">
                <h3>课程汇总</h3>
           
              </div>
              <div class="button-arrow">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 20px"></div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'StudyAbroadSummary',
    data() {
      return {
        // 页面配置
        pageConfig: {
          education: {
            name: '学历汇总',
            path: '/japcol_eduback',
            icon: 'el-icon-office-building'
          },
          source: {
            name: '来源汇总',
            path: '/japcol_origin',
            icon: 'el-icon-c-scale-to-original'
          },
          
          region: {
            name: '地区汇总',
            path: '/japcol_area',
            icon: 'el-icon-location'
          },
          
          payment: {
            name: '缴费汇总',
            path: '/japcol_payamount',
            icon: 'el-icon-money'
          },
          course: {
            name: '课程汇总',
            path: '/japcol_course',
            icon: 'el-icon-school'
          }
        }
      }
    },
    mounted() {
      this.loadRecentPages()
    },
    methods: {
      // 跳转到指定页面
      goToPage(pageType) {
        const config = this.pageConfig[pageType]
        if (config) {
          // 跳转页面
          this.$router.push({
            path: config.path,
            query: {
              fromSummary: true
            }
          })
        }
      },
      
    }
  }
  </script>
  
  <style scoped>
  .content {
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    min-height: calc(100vh - 120px);
  }
  
  .summary-header {
    text-align: center;
    margin-bottom: 40px;
  }
  
  .summary-header h2 {
    color: #303133;
    margin-bottom: 10px;
    font-size: 28px;
  }
  
  .sub-title {
    color: #909399;
    font-size: 16px;
  }
  
  /* 按钮容器 */
  .summary-buttons {
    max-width: 1200px;
    margin: 0 auto 40px;
  }
  
  .button-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
  
  .button-item {
    flex: 1;
    min-width: 300px;
    margin: 10px;
    padding: 25px;
    background: #f8f9fa;
    border-radius: 12px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid transparent;
    position: relative;
    overflow: hidden;
  }
  
  .button-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    border-color: #409eff;
    background: #fff;
  }
  
  .button-item:hover .button-arrow {
    transform: translateX(5px);
    color: #409eff;
  }
  
  .button-icon {
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, #409eff, #66b1ff);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    flex-shrink: 0;
  }
  
  .button-icon i {
    font-size: 28px;
    color: white;
  }
  
  .button-content {
    flex: 1;
  }
  
  .button-content h3 {
    margin: 0 0 8px 0;
    color: #303133;
    font-size: 20px;
    font-weight: 600;
  }
  
  .button-content p {
    margin: 0;
    color: #909399;
    font-size: 14px;
  }
  
  .button-arrow {
    color: #c0c4cc;
    font-size: 20px;
    transition: all 0.3s ease;
  }
  
  /* 最近访问 */
  .recent-access {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 12px;
  }
  
  .recent-access h3 {
    margin: 0 0 15px 0;
    color: #303133;
  }
  
  .recent-list {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  
  .recent-tag {
    cursor: pointer;
    padding: 8px 16px;
    font-size: 14px;
    transition: all 0.3s ease;
  }
  
  .recent-tag:hover {
    background: #409eff;
    color: white;
    border-color: #409eff;
  }
  
  /* 响应式设计 */
  @media (max-width: 992px) {
    .button-row {
      flex-direction: column;
    }
    
    .button-item {
      min-width: 100%;
      margin: 10px 0;
    }
  }
  
  @media (max-width: 768px) {
    .summary-header h2 {
      font-size: 24px;
    }
    
    .button-icon {
      width: 50px;
      height: 50px;
      margin-right: 15px;
    }
    
    .button-icon i {
      font-size: 22px;
    }
    
    .button-content h3 {
      font-size: 18px;
    }
  }
  </style>